<template>
  <div class="grid_menu mb-5 pl-2">
    <v-card class="menu_team text-center">
      <router-link class="menu_team_link" to="/companyinformation">
        <div class="menu_team_img">
          <img src="@/assets/office-building_1.png">
        </div>
        <div>
          ข้อมูลเกี่ยวกับบริษัท
        </div>
      </router-link>
    </v-card>
    <v-card class="menu_team text-center">
      <router-link class="menu_team_link" to="/contactinformation">
        <div class="menu_team_img">
          <img src="@/assets/communicate.png">
        </div>
        <div>
          ช่องทางการติดต่อ
        </div>
      </router-link>
    </v-card>
    <v-card class="menu_team text-center">
      <router-link class="menu_team_link" to="/branchinformation">
        <div class="menu_team_img">
          <img src="@/assets/entrepreneur.png">
        </div>
        <div>
          สาขา
        </div>
      </router-link>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "MenuCompany"
}
</script>

<style scoped>
.grid_menu {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
  grid-gap: 15px 0;
}
@media only screen and (max-width: 500px) {
  .grid_menu {
    display: grid;
    grid-template-columns: 100%;
  }
}
.menu_team{
  width: 97%;
}
.menu_team>.menu_team_link {
  color: #565656;
  padding: 10px 15px 10px 15px;
  line-height: 1.45;
  transition: padding 0.35s ease 0s !important;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  outline: none;
  background-color: transparent;
  border-radius: 4px;
  text-decoration: none;
  font-size: 20px;
}
.router-link-active,
.menu_team>.menu_team_link:hover {
  color: #fff !important;
  background-image: linear-gradient(to right, #8cc63e, #91c657, #9cc66d)!important;
  transition: 0.1s !important;
  border-radius: 4px;
  font-weight: 400;
  height: 100%;
}

.menu_team_img {
  margin: auto;
  width: 50px;
}

.menu_team_img>img {
  max-width: 100%;
}
</style>
